import { cx } from "_lib/utils";
import { ConfigurationAtom, LeadFormAtom, NavbarAtom } from "_states";
import { Link, NavLink } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";

const Navbar = ({ type = "default" }: { type?: "dark" | "default" }) => {
  const configurations = useRecoilValue(ConfigurationAtom);
  const navbar = useRecoilValue(NavbarAtom);
  const setLeadFormOpen = useSetRecoilState(LeadFormAtom);

  return (
    <nav
      className={cx(
        "absolute top-0 text-white w-full z-50",
        type === "dark" ? "bg-black" : "bg-[#00000010]"
      )}
    >
      <div className="max-w-7xl flex flex-wrap items-center justify-between mx-auto">
        <Link to="/" className="w-full md:w-auto">
          <img
            alt={configurations.site_name}
            src="/logo.png"
            className="h-16 py-1 mx-auto"
          />
        </Link>
        <div className="hidden w-full md:block md:w-auto" id="navbar-default">
          <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0">
	    {navbar.map((n, key) => (
              <li key={key}>
                <NavLink to={n.link} className={"block py-2 px-3 rounded"}>
                  {n.text}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
